import React from 'react';
import { StatsGrid } from './StatsGrid/StatsGrid.tsx';
import { BadgesRow } from './BadgesRow/BadgesRow.tsx';
import styles from './OverviewTab.module.scss';
export const OverviewTab = ({ stats, badges })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement(StatsGrid, {
        stats: stats
    }), /*#__PURE__*/ React.createElement(BadgesRow, {
        badges: badges
    }));
};
